// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* div /deep/ .el-input__suffix {\n    right: -15px;\n    -webkit-transition: all .3s;\n    transition: all .3s;\n} */\n#quxiao-bu-k[data-v-6ecdec7d] {\n  width: 82px;\n  height: 33px;\n  border-radius: 5px;\n  color: #fff;\n  background: #081A29;\n}\n.dialog-isReadOnly-bu-k[data-v-6ecdec7d] {\n  width: 100%;\n  margin-right: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
